// src/components/SidebarMenu/useNaturaVisibility.js
import { useCallback } from 'react'
import { useQuery } from 'react-query'
import { fetchNaturaAllowedWarehouses } from '../../services'
import { NATURA_REPLENISHMENTS } from '../../navigation/constants'
import { userHasPermission } from '../../navigation/NavegationRoutes'

export function useNaturaVisibility(warehouse_id, user) {
    const hasNaturaPermission = user?.id && userHasPermission(user, 'natura_inbound_management')

    const { data: naturaAllowedWarehouses } = useQuery(
        'naturaAllowedWarehouses',
        fetchNaturaAllowedWarehouses,
        {
            enabled: !!hasNaturaPermission,
            refetchOnWindowFocus: false,
            staleTime: 1000 * 60 * 60,
        }
    )

    const isNaturaVisible = useCallback(
        (item) => {
            if (item.href !== NATURA_REPLENISHMENTS) return true
            if (!warehouse_id) return false
            if (!naturaAllowedWarehouses) return false
            return naturaAllowedWarehouses.includes(parseInt(warehouse_id))
        },
        [warehouse_id, naturaAllowedWarehouses]
    )

    return isNaturaVisible
}
